import styled from "@emotion/styled";
import { BlockState } from "../types";
import React, { useCallback, useEffect, useState } from 'react';
import image from './scrimblo.gif';
import { EAST, NORTH, SOUTH } from "../constants";
import { canEnter, success } from "../utils";
import { playRightSound, playStepSound, playWallSound, playWrongSound } from "..";

interface ScrimbloType {
    route: number[];
    grid: number[][];
    setSuccess: Function;
    setFailure: Function;
}

interface ScrimbloProps {
    x: number;
    y: number;
}

export const Scrimblo: React.FC<ScrimbloType> = ({grid, route,setSuccess, setFailure }) => {
    const speed = 25;
    const StyledScrimblo = styled.img`
        position: absolute;
        top: ${(props: ScrimbloProps) => props.y}px; 
        width: 25px;
        padding-left: 3px;
        left: ${(props: ScrimbloProps) => props.x}px;
        display: inline-block;
    `
    const [routeIndex, setRouteIndex] = useState(0);
    //grid position
    const [worldLocation, setWorldLocation] = useState([1, 1]);



    //TODO don't let them go out of the maze, or past a wall
    const goNorth = useCallback(() => {
        const goalX = worldLocation[0];
        const goalY = worldLocation[1] - 1;
        if(canEnter(grid,goalX,goalY)){
            setWorldLocation([goalX,goalY]);
            playStepSound();
        }else{
            playWallSound();
        }
    }, [worldLocation]);

    const goSouth = useCallback(() => {
        const goalX = worldLocation[0];
        const goalY = worldLocation[1] + 1;
        if(canEnter(grid,goalX,goalY)){
            setWorldLocation([goalX,goalY]);
            playStepSound();
        }else{
            playWallSound();
        }
    }, [worldLocation]);

    const goEast = useCallback(() => {
        const goalX = worldLocation[0]+1;
        const goalY = worldLocation[1];
        if(canEnter(grid,goalX,goalY)){
            setWorldLocation([goalX,goalY]);
            playStepSound();
        }else{
            playWallSound();
        }
    }, [worldLocation]);

    const goOther = useCallback(() => {
        const goalX = worldLocation[0]-1;
        const goalY = worldLocation[1];
        if(canEnter(grid,goalX,goalY)){
            setWorldLocation([goalX,goalY]);
            playStepSound();
        }else{
            playWallSound();
        }
    }, [worldLocation]);


    const tick = useCallback(() => {
        const currentMove = route[routeIndex];
        if (currentMove === NORTH) {
            goNorth();
        } else if (currentMove === EAST) {
            goEast();
        } else if (currentMove === SOUTH) {
            goSouth();
        } else {
            goOther();
        }
        setRouteIndex(routeIndex +1);
    }, [routeIndex,route,goNorth, goEast, goSouth, goOther]);


    useEffect(() => {
        if(routeIndex >= route.length){
            if(success(grid,worldLocation[0], worldLocation[1])){
                playRightSound();
                setSuccess(true);
            }else{
                playWrongSound();
                setFailure(true);
            }
            return;
        }
        const timer = setTimeout(() => {
            tick();
        }, 500)

        return () => {
            clearTimeout(timer);
        };

    }, [routeIndex])

    return (
        <StyledScrimblo src={image} x={worldLocation[0]*speed} y={worldLocation[1]*speed} ></StyledScrimblo>
    )



}